import { Phone } from "lucide-react";
import { CONTACT } from "../data/content";

/* Nur mobil sichtbarer, fixierter Anruf-Button (unten links, seitenübergreifend).
   Öffnet per tel:-Link die Telefon-App. */
export const MobilePhoneFab = () => (
  <a
    href={CONTACT.phoneHref}
    data-testid="mobile-phone-fab"
    aria-label={`Fussboden Blum anrufen: ${CONTACT.phone}`}
    className="lg:hidden fixed bottom-5 left-5 z-40 group"
  >
    <span
      className="absolute inset-0 rounded-full bg-[#D32F2F]/40 animate-ping [animation-duration:2.5s]"
      aria-hidden="true"
    />
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#D32F2F] text-white border border-white/20 shadow-[0_12px_28px_-10px_rgba(211,47,47,.8)] transition-transform duration-200 group-active:scale-90">
      <Phone className="w-6 h-6" />
    </span>
  </a>
);
